import { DomWindow, DomWindowBounds, DomWindowConfig } from "../DomWindow";
import { PluginBase } from "../Plugin";
import { EL } from "../util/DomUtils";

const titleBarHeight = 15.5;
function sum(array) {
  return array.reduce((acc, x) => acc + x, 0);
}
function getHeight(wnd) {
  return Math.max(titleBarHeight, wnd.$wnd[0].clientHeight )
}

export class DockLayoutPlugin extends PluginBase {
    colLeft: Column;
    colRight: Column;

    constructor() {
        super()
        const self = this;
        if (DomWindowConfig.isMobileMode) return;
        document.body.append(this[Symbol.dispose].adopt(EL('style', {}, `
            #myMemo {border-width: 3px;}
            #contentArea{ background: #bbb; }
            #contentAreaHorizontal {border-left: 1px solid #000; border-right: 1px solid #000;}
            #toolbar{ border-image: linear-gradient( #000,  #bbb); border-bottom: 5px image; }
            .windowOuterDiv .windowTitleBar button, .windowOuterDiv .windowTitleBar span {padding-top: 4px; padding-bottom: 4px;}
            .windowOuterDiv.docked .windowTitleBar button, .windowOuterDiv.docked .windowTitleBar span {padding-top: 0; padding-bottom: 0;}
        `), (x) => x.remove()));
        
        this[Symbol.dispose].defer(() => {
            var ca = document.getElementById("contentAreaHorizontal");
            ca.style.marginLeft = "0";
            ca.style.marginRight = "0";
        });

        self.colLeft = new Column(0, 200);
        self.colRight = new Column(window.innerWidth-260, 260);
        function reorder() {
            var ca = document.getElementById("contentAreaHorizontal");
            ca.style.marginLeft = self.colLeft.reorder() ? `${self.colLeft.xx - 1}px` : "0";
            ca.style.marginRight = self.colRight.reorder() ? `${self.colRight.xx - 1}px` : "0";
        }
        function onResizeHandler() {
            self.colRight.x = window.innerWidth-self.colRight.xx;
            reorder();
        }

        this.hook(DomWindow.prototype, 'afterMove', function(next) {
            self.colLeft.updateMembership(this);
            self.colRight.updateMembership(this);
            reorder();
            return next();
        });
        this.hook(DomWindow.prototype, 'afterResize', function(next) {
            self.colLeft.updateMembership(this, 'resized');
            self.colRight.updateMembership(this, 'resized');
            reorder();
            return next();
        });
        this.slot(DomWindow, 'windowCreated', function(instance) {
            if (instance.constructor.name === 'EditorWindow') instance['dockIgnore'] = true;
            self.colLeft.updateMembership(instance, 'created');
            self.colRight.updateMembership(instance, 'created');
            reorder();
        });
        this.slot(DomWindow, 'windowClosed', function(instance) {
            self.colLeft.wnds.delete(instance);
            self.colRight.wnds.delete(instance);
            reorder();
        });
        this.slot(window, 'resize', onResizeHandler, []);
    }
}
class Column {
    keepSizeOf : DomWindow = null;
    keepSizeUpTo : DomWindow = null;
    wnds : Set<DomWindow>;
    constructor(public x : number, public xx : number, public top : number = 45, public paddingBottom : number = 0) {
        this.keepSizeOf = null;
        this.wnds = new Set(this.filter(Object.values(DomWindow.windows)));
        for(const wnd of this.wnds)
            wnd.$wnd.addClass('docked');
    }
    filter(wnds: DomWindow[]) {
        return wnds.filter(wnd => {
            if (wnd['dockIgnore'] || !wnd.$wnd.is(':visible')) return false;
            var bounds = wnd.getBounds() as DomWindowBounds;
            return (bounds.x >= this.x-30 && (bounds.x+bounds.xx) <= this.x+this.xx+100);
        });
    }
    updateMembership(wnd: DomWindow, eventType = '') {
        var shouldBeMember = this.filter([wnd]).length;
        var alreadyMember = this.wnds.has(wnd);
        this.keepSizeOf = null; this.keepSizeUpTo = null;

        if (shouldBeMember && !alreadyMember) {  // the window was moved into the column or...
            this.wnds.add(wnd);
            wnd.$wnd.addClass('docked');
            if (eventType === 'created') this.keepSizeOf = wnd;  // ...the window was created

        } else if (!shouldBeMember && alreadyMember) {  // the window was moved out of the column
            this.wnds.delete(wnd);
            wnd.$wnd.removeClass('docked');

        } else if (shouldBeMember && alreadyMember) {   // the window itself was resized/moved
            if (eventType === 'resized') this.keepSizeUpTo = wnd; else this.keepSizeOf = wnd;
        }
    }
    reorder(){
        var top = this.top;
        var hasItems = false;
        var wnds : [DomWindow, DOMRect][] = [...this.wnds].map(wnd => [wnd, wnd.container.getBoundingClientRect()]);
        wnds.sort(([_, a],[__, b]) => (a.y - b.y));
        let keepSizeOf = this.keepSizeUpTo ? wnds.slice(0, 1 + wnds.findIndex(([wnd,_]) => wnd === this.keepSizeUpTo)).map(([wnd,_]) => wnd) : this.keepSizeOf ? [ this.keepSizeOf ] : [];
        
        let availHeightOrig = window.innerHeight - top - this.paddingBottom;
        let availHeight = availHeightOrig - keepSizeOf.reduce((p, wnd) => p + wnd.container.getBoundingClientRect().height, 0);
        if (availHeight < titleBarHeight * (wnds.length - keepSizeOf.length)) { keepSizeOf = []; availHeight = availHeightOrig; }

        let heights = wnds.map(([wnd, rect]) => (keepSizeOf.indexOf(wnd) !== -1) ? 0 : rect.height);
        let sumHeight = sum(heights);
        let ratios = heights.map(x => x / sumHeight);

        for (var i = 0; i < wnds.length; i++) {
            let [wnd, _] = wnds[i];
            wnd.$wnd.css("top", top + "px").css("left",this.x + "px").css("width",this.xx + "px");
            if (!wnd.collapsed && keepSizeOf.indexOf(wnd) === -1) wnd.$wnd.css("height", (availHeight * ratios[i] ) + "px");
            wnd.saveWinPos();
            top += wnd.$wnd[0].clientHeight+3;
            if (!wnd.collapsed && !wnd.hidden) hasItems = true;
        }
        this.keepSizeOf = null; this.keepSizeUpTo = null;
        return hasItems;
    }
}
